import { useState } from "react";
import "./Nav.css";
import logo from "@/assets/logo-horizontal.svg";
import { useT, useLang } from "@/i18n/context";

export function Nav() {
  const t = useT();
  const { lang, toggle } = useLang();
  const [menuOpen, setMenuOpen] = useState(false);
  const links = [
    { href: "#about", label: t.nav.about },
    { href: "#services", label: t.nav.services },
    { href: "#method", label: t.nav.method },
    { href: "#locations", label: t.nav.locations },
    { href: "#contact", label: t.nav.contact },
  ];
  return (
    <header className="nav">
      <div className="container nav__inner">
        <a href="#top" className="nav__logo" aria-label="TUXIA">
          <img src={logo} alt="TUXIA" height={28} />
        </a>
        <nav className={`nav__links${menuOpen ? " nav__links--open" : ""}`} aria-label="Primary">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)}>{l.label}</a>
          ))}
        </nav>
        <button className="nav__hamburger" type="button" onClick={() => setMenuOpen((o) => !o)} aria-label="Menu" aria-expanded={menuOpen}>
          ☰
        </button>
        <button className="nav__lang" type="button" onClick={toggle} aria-label="Switch language">
          {lang === "it" ? "EN" : "IT"}
        </button>
      </div>
    </header>
  );
}

export default Nav;
